<template>
  <div class="Wdgt-Search-Trending">
    <div class="Wdgt-Search-Trending__tbl" ref="table">
      <div class="Wdgt-Search-Trending__row" :style="gridColumn" v-for="coin in trendingCoins" :key="coin.symbol" v-if="!props.isLoading">

        <TagValue :type="'pale'" data-id>
          #{{ coin.rank }}
        </TagValue>
        <BlockProject :image="coin.image" :link="coin.dropstab_url" :name="coin.name" :prefix="coin.symbol" data-block-project />
        <TagValuePercent :percent="formatPercent(coin.change_1d_usd)" data-tag-value>
          ${{ coin.price_usd }}
        </TagValuePercent>
        <TagList :list="getMarketParams(coin)" data-m-cap/>
        <div class="Wdgt-Search-Trending__icons" data-icons>
          <TagIconValue :link="coin.exchange_link" :image="coin.exchange_image_link" v-if="coin.trading_pair">
            {{ coin.trading_pair }}
          </TagIconValue>
          <TagSmartContract :link="coin.explorer_url" :image="coin.networkImage" :contract="coin.contract" v-if="coin.contract">

          </TagSmartContract>
          <TagIcon class="Wdgt-Search-Trending__drop-btn" :link="coin.dexscreener_url" :image="'https://dropstab.com/icons/brands/contracts-dexscreener.svg'" v-if="coin.dexscreener_url"/>
          <TagIcon class="Wdgt-Search-Trending__drop-btn" :link="coin.dropstab_url" :image="get_dropstabIcon"/>
        </div>
      </div>
      <template v-else>
        <div class="Wdgt-Search-Trending__row" v-for="index in get_skeletCount" :key="index">
          <SkeletItem style="width: 41px" :height="24"/>
          <div class="Wdgt-Search-Trending__skelet-project">
            <SkeletAvatar class="Wdgt-Search-Trending__avt-skelet"/>
            <SkeletItem style="width: 102px" :height="24"/>
          </div>
          <SkeletItem style="width: 92px" :height="24"/>
          <SkeletItem style="width: 200px" :height="24"/>
          <div class="Wdgt-Search-Trending__icons">
            <SkeletItem style="width: 94px" :height="24"/>
            <SkeletItem class="Wdgt-Search-Trending__drop-btn" style="width: 24px" :height="24"/>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import {defineProps, computed, ref, nextTick, watch, onMounted} from 'vue';
import {Props} from './scripts/props.js';
import {LARGE_NUMBERS} from './scripts/largeNumbers.js';
//---------------------------------------
import TagValue from '@ui/Tags/TagValue/TagValue.vue';
import BlockProject from '@ui/Blocks/BlockProject/BlockProject.vue';
import TagValuePercent from '@ui/Tags/TagValuePercent/TagValuePercent.vue';
import TagList from '@ui/Tags/TagList/TagList.vue';
import TagIconValue from '@ui/Tags/TagIconValue/TagIconValue.vue';
import TagSmartContract from '@shared/UI/Tags/TagSmartContract/TagSmartContract.vue';
import TagIcon from '@ui/Tags/TagIcon/TagIcon.vue';
import SkeletItem from '@ui/Skeletons/SkeletItem/SkeletItem.vue';
import SkeletAvatar from '@ui/Skeletons/SkeletAvatar/SkeletAvatar.vue';
//---------------------------------------
const props = defineProps(Props());
//---------------------------------------
const table = ref(null);
const gridColumn = ref('');
//---------------------------------------
onMounted(async () => {
  await nextTick();
  updateGrid();
})
//Получить ссылку на иконку дропстаб
const get_dropstabIcon = computed(() => require('@shared/images/icons/dropstabIcon.svg'));
//Получить кол-во заглушек
const get_skeletCount = computed(() => props.isSearchResult ? 3 : 5);
//---------------------------------------
//Форматировать процент
const formatPercent = (percent) => {
  return ((percent !== null) && (percent !== undefined)) ? Number(percent.toFixed(2)) : undefined;
};
//Получить сокрощенное значение и префикс
const getLargeNumberString = (inp) => {
  if (isNaN(inp)) return "N/A";
  for (const item of LARGE_NUMBERS) {
    const value = inp / item.size;
    if (value >= 1) return `${value.toFixed(2)} ${item.shortDesc}`;
  }
  return inp.toFixed(2);
};
//Сделать имя монеты короче
const truncatedName = (name) => {
  if (name.length <= 12) return name;
  return name.slice(0, 12) + '...';
};
//Получить словарь (ключ/значение) для компонента Tag Lsit
const getMarketParams = (coin) => {
  return {
    'M.Cap': coin.market_cap ? `$${getLargeNumberString(coin.market_cap)}` : 'N/A',
    'FDV': coin.fdv ? `$${getLargeNumberString(coin.fdv)}` : 'N/A'
  };
};
//Определить ширину самого длинного названия проекта
const toDefineMaxWidth = (dataAttr) => {
  let localMaxWidth = 0;
  const items = table.value.querySelectorAll(`[${dataAttr}]`);
  if (items.length < 2) return;
  items.forEach((item) => {
    if (localMaxWidth < item.offsetWidth) localMaxWidth = item.offsetWidth;
  });
  return localMaxWidth;
}
//Обновить грид сетку
const updateGrid = () => {
  const gridId = toDefineMaxWidth('data-id');
  const gridBlockProject = toDefineMaxWidth('data-block-project');
  const gridTagValue = toDefineMaxWidth('data-tag-value') * 1.2;
  const gridMCap = toDefineMaxWidth('data-m-cap');
  const gridIcon = toDefineMaxWidth('data-icons');
  gridColumn.value = `grid-template-columns: ${gridId}px ${gridBlockProject}px ${gridTagValue}px ${gridMCap}px minmax(${gridIcon}px, 1fr)`
}
//---------------------------------------
watch(() => props.isLoading, async (newVal) => {
  await nextTick();
  updateGrid();
});
</script>

<style lang="scss">
@import "./styles/_conf";
</style>
